import Navbar from "../Components/navbar";
import Content from "../Components/content";  
import React from "react";  


const Main = () => {
  return (
    <div>
      <Navbar />
      <Content />
    </div>
  );
};

export default Main;